const getOrCreateLegendList = (container) => {
  if (!container || container.nodeType !== 1) return null;

  let ul = container.querySelector('ul');
  if (!ul) {
    ul = document.createElement('ul');
    container.appendChild(ul);
  }
  ul.classList.add('chart-legend');
  return ul;
};

const htmlLegendPlugin = {
  id: 'htmlLegend',
  afterUpdate (chart, args, options) {
    const ul = getOrCreateLegendList(options.container);

    // Remove old legend items
    while (ul.firstChild) {
      ul.firstChild.remove();
    }

    // Reuse the built-in legendItems generator
    const items = chart.options.plugins.legend.labels.generateLabels(chart);
    items.forEach(item => {
      const li = document.createElement('li');

      li.onclick = () => {
        const { type } = chart.config;
        if (type === 'pie' || type === 'doughnut') {
          // Pie and doughnut charts only have a single dataset and visibility is per item
          chart.toggleDataVisibility(item.index);
        } else {
          chart.setDatasetVisibility(item.datasetIndex, !chart.isDatasetVisible(item.datasetIndex));
        }
        chart.update();
      };

      // List item
      li.classList.add('chart-legend-item');
      li.classList.toggle('active', !item.hidden);

      // Color box
      const boxSpan = document.createElement('span');
      boxSpan.classList.add('chart-legend-box');
      boxSpan.style.setProperty('--chart-legend-color', item.fillStyle);

      // Text
      const textContainer = document.createElement('p');
      textContainer.classList.add('chart-legend-label');

      const text = document.createTextNode(item.text);
      textContainer.appendChild(text);

      li.appendChild(boxSpan);
      li.appendChild(textContainer);

      // Optional value column (e.g. percentage), rendered at the end of the item
      if (typeof options.formatValue === 'function') {
        const valueSpan = document.createElement('span');
        valueSpan.classList.add('chart-legend-value');
        valueSpan.textContent = options.formatValue(chart, item.index);
        li.appendChild(valueSpan);
      }

      ul.appendChild(li);
    });
  },
};

export default htmlLegendPlugin;